"use client";
import React from "react";
import { useCurrency } from "@/app/providers/currencyContext";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { useTranslations } from "next-intl";

export const SingleProductDescriptionFocusedPrice = ({
  product,
  isGiftCardProduct,
}: any) => {
  const { format } = useCurrency();
  const t = useTranslations("SingleProductDescriptionFocusedPrice");

  if (!product.available) {
    return (
      <span className="self-start pt-[2px] font-medium">{t("soldOut")}</span>
    );
  }

  return (
    <span
      data-testid={applyDataTestId(pom.products.productPrice)}
      className="pt-[3px] text-sm font-medium pl-3"
    >
      {!isGiftCardProduct ? format(product.price) : t("customValue")}
    </span>
  );
};
